var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"id":"liqButton","depressed":"","small":"","color":"primary"},on:{"click":function($event){return _vm.launchDialog()}}},[_vm._v("\n    Informe Liquidación\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }